import { render } from "./ReturnPolicy.vue?vue&type=template&id=025246dc"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__